import dayjs from 'dayjs';
import {useReservation} from 'context/reservation';
import {useFetchCheckoutSettings} from './useFetchCheckoutSettings';
import {useSummary} from 'context/summary';
import {OFFER_STATUSES} from '@guestapp/sdk';
import ChekinProSettings from 'ChekinProSettings';
import {getFeatureFlags} from 'utils/features';
import {IS_SDK_MODE} from 'routes/constants';

function getIsCheckoutDate(currentCheckoutDate?: string, checkoutTime?: string): boolean {
  if (!currentCheckoutDate || !checkoutTime) {
    return false;
  }
  const currentDate = dayjs();
  const checkoutDate = dayjs(currentCheckoutDate);
  const currentTime = currentDate.format('HH:mm');

  return checkoutDate.isSameOrBefore(currentDate, 'day') && currentTime >= checkoutTime;
}

function useCheckoutSettings() {
  const {housing, data: reservation} = useReservation();
  const {data: summary} = useSummary();
  const {data: checkoutSettings, isLoading} = useFetchCheckoutSettings({
    checkoutSettingsId: housing?.check_out_settings_id,
  });
  const hasMozio =
    summary?.mozio_status === OFFER_STATUSES.active && !ChekinProSettings.isSDK;
  const isCheckoutDate = getIsCheckoutDate(
    reservation?.check_out_date,
    checkoutSettings?.check_out_button_availability_time,
  );
  const isSurveyFlowEnabled = checkoutSettings?.is_survey_enabled;
  const isCheckoutCompleted = isSurveyFlowEnabled
    ? reservation?.check_out_flow_status === 'FEEDBACK_SUBMITTED'
    : reservation?.check_out_flow_status === 'PAID';
  const isCheckoutEnabled =
    !IS_SDK_MODE &&
    !!housing?.check_out_settings_id &&
    getFeatureFlags('IT_4407_CHECK_OUT');
  const isAvailable = Boolean(housing?.check_out_settings_id) && isCheckoutDate;

  return {
    checkoutSettings,
    isAvailable,
    checkoutFlowStatus: reservation?.check_out_flow_status,
    isSurveyFlowEnabled,
    isCheckoutCompleted: !isLoading && isCheckoutCompleted,
    isLoading,
    isCheckoutEnabled,
    hasMozio,
  };
}

export {useCheckoutSettings};
